import { render } from "./support_document.html?vue&type=template&id=34950aea&scoped=true&external"
import script from "./support_document.js?vue&type=script&lang=js&external"
export * from "./support_document.js?vue&type=script&lang=js&external"

import "./SupportDocument.vue?vue&type=style&index=0&id=34950aea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34950aea"]])

export default __exports__